module.exports = __webpack_public_path__ + "static/media/inicio-sucursal-virtual.07344549.svg";